var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"300px"},attrs:{"id":"map-popup"}})
}
var staticRenderFns = []

export { render, staticRenderFns }